import {
  always,
  complement,
  curry,
  ifElse,
  isNil,
  pipe,
  prop,
  propSatisfies,
} from 'ramda'

// For styled-components:
// <Comp fontSize="15px" width="30px" />
// 1.
// const Comp = styled.div`
//   ${useProp('fontSize')('font-size')}
// `
// => font-size: 15px;
// 2.
// const Comp2 = styled.div`
//   ${useProp('width')}
// `
// => width: 30px;

export default curry((propKey, label = propKey) =>
  ifElse(
    propSatisfies(complement(isNil), propKey),
    pipe(prop(propKey), value => `${label}: ${value};`),
    always(''),
  ),
)
